export default __webpack_public_path__ + "static/mateuszm-1c1fda41b7d3eb743583592a13e4c084.png";